import React from "react";
import {FIELD_TYPE, FORMAT_TIME, tabKeys} from "types/enums";
import {ColumnsType} from "antd/es/table";
import {ColumnProps} from "types/models";
import moment from "moment";
import dayjs from "dayjs";

// import DilateStatusCard from "./DilateStatusCard/DilateStatusCard";
import {listGender} from "data/list";
import {DataFormField} from "types/models/input-field-type";
import {gioiTinhOptions} from "assets/constants/select-catagory-options";
import {parseDatetime, toDateTime} from "helper/format-date";
import {
  convertIosStringToDate,
  convertIosStringToDateDayjs,
  convertIosStringToDateMoment,
  formatDateToString,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import {Select} from "antd";
const {INPUT, SELECT, DATE, NUMBER} = FIELD_TYPE;

const dataListPatientResidentialFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
    expand: false,
  },
  {
    type: INPUT,
    label: "Mã PK",
    name: "maPhieuKham",
    expand: false,
  },
  {
    type: INPUT,
    label: "Tên bệnh nhân",
    name: "hoVaTen",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    expand: false,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "soDienThoai",
    expand: false,
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChi",
    expand: true,
  },
  {
    type: INPUT,
    label: "Số BHYT",
    name: "soTheBaoHiemYTe",
    expand: true,
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    expand: true,
    options: [
      {
        value: 0,
        label: "Nam",
      },
      {value: 1, label: "Nữ"},
    ],
  },
  {
    type: INPUT,
    label: "BS chỉ định",
    name: "tenBacSyDieuTri",
    expand: true,
  },
  {
    type: INPUT,
    label: "PP phẫu thuật",
    name: "phuongPhapPhauThuat",
    expand: true,
  },
  {
    type: DATE,
    label: "Từ ngày",
    name: "ngayTaoTu",
    expand: false,
    disableDate: false,
  },
  {
    type: DATE,
    label: "Đến ngày",
    name: "ngayTaoDen",
    expand: false,
    disableDate: false,
  },
  {
    type: SELECT,
    label: "Trạng thái",
    name: "trangThai",
    options: [
      {value: 0, label: "Đã nhập viện "},
      {value: 1, label: " Chờ tiếp nhận"},
      {value: 2, label: "Xuất viện"},
    ],
    expand: true,
  },
];

const allColumnsResidential: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    isResizable: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    align: "center",
  },
  {
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    align: "center",
    isResizable: true,
  },

  {
    title: "Mã PK",
    dataIndex: "idPhieuKham",
    show: true,
    align: "center",
    isResizable: true,
  },
  {
    title: "Tên BN",
    dataIndex: "hoVaTen",
    show: true,
    align: "left",
    isResizable: true,
  },
  {
    title: "Giới tính",
    dataIndex: "gioiTinh",
    show: true,
    isResizable: true,
    align: "left",
    render: (value, record, index) =>
      gioiTinhOptions.find(it => it.value === value)?.label || "",
  },
  {
    title: "Ngày sinh",
    dataIndex: "ngaySinh",
    show: true,
    isResizable: true,
    align: "center",
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",
  },
  {
    title: "Số điện thoại",
    dataIndex: "soDienThoai",
    show: true,
    isResizable: true,
    align: "right",
  },
  {
    title: "BS chỉ định",
    dataIndex: "tenBacSyDieuTri",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Chỉ định",
    dataIndex: "dichVu",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Trạng thái",
    dataIndex: "idTrangThaiNoiTru",
    show: false,
    isResizable: true,
    align: "left",
    // render: (value, record, index) => value
  },
  {
    title: "Ngày nhập viện",
    dataIndex: "ngayNhapVien",
    show: true,
    isResizable: true,
    align: "center",
    render: (value, record, index) =>
      value ? dayjs(value).format(FORMAT_TIME.dateTime) : "",
  },
  // { title: "Số BHYT", dataIndex: "maTheBhyt", show: false, align: "left" },
  {
    title: "Địa chỉ",
    dataIndex: "diaChi",
    show: true,
    align: "left",
    isResizable: true,
  },
  // { title: "Khu khám", dataIndex: "khuKham", show: false, align: "left" },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    isResizable: true,
    align: "center",
    fixed: "right",
  },
];

export {dataListPatientResidentialFields, allColumnsResidential};
